export default __webpack_public_path__ + "static/media/beats_logo_menu.042edd81.svg";